import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdfConverter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#F43F3F" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16 9.5h-5.44c-.896 0-1.344 0-1.686.174a1.6 1.6 0 0 0-.7.7C8 10.716 8 11.164 8 12.06V16c0 .745 0 1.118.122 1.412a1.6 1.6 0 0 0 .866.866c.294.122.666.122 1.412.122m5.76 6.6h5.28c.896 0 1.344 0 1.686-.174a1.6 1.6 0 0 0 .7-.7c.174-.342.174-.79.174-1.686v-5.28c0-.896 0-1.344-.174-1.686a1.6 1.6 0 0 0-.7-.7c-.342-.174-.79-.174-1.686-.174h-5.28c-.896 0-1.344 0-1.686.174a1.6 1.6 0 0 0-.7.7c-.174.342-.174.79-.174 1.686v5.28c0 .896 0 1.344.174 1.686a1.6 1.6 0 0 0 .7.7c.342.174.79.174 1.686.174M14.4 9.5h4.428m0 0-2.328-2m2.328 2-2.328 2"
    />
  </svg>
);
export default SvgPdfConverter;
